var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9334 1.2002C3.27066 1.2002 2.7334 1.73745 2.7334 2.4002C2.7334 3.06294 3.27066 3.6002 3.9334 3.6002H5.39647L5.76314 5.06689C5.76699 5.08384 5.7712 5.10067 5.77575 5.11734L7.40443 11.632L6.33334 12.7031C4.82143 14.215 5.89222 16.8002 8.0304 16.8002H18.3333C18.9961 16.8002 19.5333 16.2629 19.5333 15.6002C19.5333 14.9375 18.9961 14.4002 18.3333 14.4002L8.0304 14.4002L9.2304 13.2002H17.1334C17.5879 13.2002 18.0034 12.9434 18.2067 12.5368L21.8067 5.33685C21.9927 4.96487 21.9728 4.5231 21.7542 4.16932C21.5355 3.81554 21.1493 3.6002 20.7334 3.6002H7.87033L7.49757 2.10915C7.36402 1.57495 6.88404 1.2002 6.3334 1.2002H3.9334Z",
    fill: "#108F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5334 19.8002C19.5334 20.7943 18.7275 21.6002 17.7334 21.6002C16.7393 21.6002 15.9334 20.7943 15.9334 19.8002C15.9334 18.8061 16.7393 18.0002 17.7334 18.0002C18.7275 18.0002 19.5334 18.8061 19.5334 19.8002Z",
    fill: "#108F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1334 21.6002C9.12751 21.6002 9.9334 20.7943 9.9334 19.8002C9.9334 18.8061 9.12751 18.0002 8.1334 18.0002C7.13929 18.0002 6.3334 18.8061 6.3334 19.8002C6.3334 20.7943 7.13929 21.6002 8.1334 21.6002Z",
    fill: "#108F47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.6eafb6852bfedf68559c3595b5cb38b8.svg";
export { ForwardRef as ReactComponent };